module.exports = __webpack_public_path__ + "static/media/pr.0811a051.svg";